import * as S from "./PublicationContent.style.js"

const PublicationContent = () => {
    return (
        <S.Container>
            <S.Title variant="headline-02">Transparência é abrir nossos documentos para você e o mercado</S.Title>
            <S.Paragraph><strong>Para nós, colaborar é essencial.</strong> Acreditamos no poder do conhecimento como agente de transformação. Por isso, disponibilizamos aqui nossos principais documentos e estudos técnicos. Um ambiente de pesquisa e referência para você consultar, conhecer e também somar.</S.Paragraph>
        </S.Container>
    ); 
};

export default PublicationContent;
